var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light Dark Mode"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 35,
    rx: 3.5,
    fill: "#232331"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 35,
    rx: 3.5,
    stroke: "#40404E"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 48,
    y1: 8.5,
    x2: 4.37114e-8,
    y2: 8.5,
    stroke: "#40404E"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 2",
    x1: 12.5,
    y1: 35,
    x2: 12.5,
    y2: 8,
    stroke: "#40404E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3715",
    x: 17,
    y: 12,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#727C8D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3716",
    x: 17,
    y: 18,
    width: 26,
    height: 2,
    rx: 1,
    fill: "#40404E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3720",
    x: 17,
    y: 22,
    width: 26,
    height: 2,
    rx: 1,
    fill: "#40404E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3721",
    x: 17,
    y: 26,
    width: 26,
    height: 2,
    rx: 1,
    fill: "#40404E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3722",
    x: 17,
    y: 30,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#40404E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3717",
    x: 3,
    y: 3,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#40404E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3718",
    x: 12,
    y: 3,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#40404E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3719",
    x: 37,
    y: 3,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#068EFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTheme);
export default __webpack_public_path__ + "static/media/dark-theme.41998e021eaa41d716462eb39bc0ef27.svg";
export { ForwardRef as ReactComponent };